import { Trash } from "lucide-react";
import React, { useState } from "react";

export const MedicationForPain = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [addMedication, setAddMedication] = useState(1);
  const [currentMedication, setCurrentMedication] = useState(0);
  const [addedMedication, setAddedMedication] = useState([]);
  const [haveDisabilityForPain, setHaveDisabilityForPain] = useState("No");
  const [editingIndex, setEditingIndex] = useState(null); // Track which medication is being edited
  const [medicationInfo, setMedicationInfo] = useState({
    medication: "",
    dosage: "",
    frequency: "",
    frequencyOther: "", // For "Other" frequency option
    taken: "",
  });

  const allMedications = [
    {
      id: 1,
      title: "Add Medication Info",
    },
    {
      id: 2,
      title: "Medication",
    },
    {
      id: 3,
      title: "Dose",
    },
    {
      id: 4,
      title: "Frequency",
    },
    {
      id: 5,
      title: "Period Approx. Taken",
    },
  ];

  const handleNext = () => {
    if (currentMedication < allMedications.length) {
      setCurrentMedication((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentMedication >= 1) {
      setCurrentMedication((prev) => prev - 1);
    }
  };

  const renderCurrentMedication = () => {
    switch (currentMedication) {
      case 0:
        return (
          <>
            <button
              type="button"
              onClick={handleNext}
              className=" rounded-full btnGraiden bg-[#317BDB] shadowBTNs  text-white font-mainFont font-[500] min-w-[15%] py-3 px-6 text-[1vw] mt-[2%]"
            >
              {allMedications[currentMedication].title} +
            </button>
          </>
        );
        break;
      case 1:
        return (
          <>
            <div className="flex flex-col justify-center items-center gap-4 my-3 w-[30%]">
              <label className="text-[#333333] font-mainFont font-[600] text-center text-[1.1vw]">
                {allMedications[currentMedication].title}
              </label>
              <input
                className="w-full py-3 rounded-full font-mainFont placeholder:font-[400] font-[500] px-4 border border-[#CDCDCD] bg-[#F8F8F8] inputShadow focus:ring-none outline-none"
                placeholder="Enter Medicine Name"
                type="text"
              />
            </div>
            <div className="w-[30%] flex justify-around items-center ">
              <button
                type="button"
                onClick={handlePrevious}
                className=" rounded-full btnGraiden bg-[#333333] shadowBTNs  text-white font-mainFont font-[500] min-w-[30%] py-3 px-6 text-[1vw] mt-[2%]"
              >
                Previous
              </button>
              <button
                type="button"
                onClick={handleNext}
                className=" rounded-full btnGraiden bg-[#333333] shadowBTNs  text-white font-mainFont font-[500] min-w-[30%] py-3 px-6 text-[1vw] mt-[2%]"
              >
                Next
              </button>
            </div>
          </>
        );
        break;

      case 2:
        return (
          <>
            <div className="flex flex-col justify-center items-center gap-4 my-3 w-[30%]">
              <label className="text-[#333333] font-mainFont font-[600] text-center text-[1.1vw]">
                {allMedications[currentMedication].title}
              </label>
              <input
                className="w-full py-3 rounded-full font-mainFont placeholder:font-[400] font-[500] px-4 border border-[#CDCDCD] bg-[#F8F8F8] inputShadow focus:ring-none outline-none"
                placeholder="Enter Dosage"
                type="number"
              />
            </div>
            <div className="w-[30%] flex justify-around items-center ">
              <button
                type="button"
                onClick={handlePrevious}
                className=" rounded-full btnGraiden bg-[#333333] shadowBTNs  text-white font-mainFont font-[500] min-w-[30%] py-3 px-6 text-[1vw] mt-[2%]"
              >
                Previous
              </button>
              <button
                type="button"
                onClick={handleNext}
                className=" rounded-full btnGraiden bg-[#333333] shadowBTNs  text-white font-mainFont font-[500] min-w-[30%] py-3 px-6 text-[1vw] mt-[2%]"
              >
                Next
              </button>
            </div>
          </>
        );
        break;
      case 3:
        return (
          <>
            <div className="flex flex-col justify-center items-center gap-4 my-3 w-[30%]">
              <label className="text-[#333333] font-mainFont font-[600] text-center text-[1.1vw]">
                {allMedications[currentMedication].title}
              </label>
              <input
                className="w-full py-3 rounded-full font-mainFont placeholder:font-[400] font-[500] px-4 border border-[#CDCDCD] bg-[#F8F8F8] inputShadow focus:ring-none outline-none"
                placeholder="Enter Times/Day"
                type="number"
              />
            </div>
            <div className="w-[30%] flex justify-around items-center ">
              <button
                type="button"
                onClick={handlePrevious}
                className=" rounded-full btnGraiden bg-[#333333] shadowBTNs  text-white font-mainFont font-[500] min-w-[30%] py-3 px-6 text-[1vw] mt-[2%]"
              >
                Previous
              </button>
              <button
                type="button"
                onClick={handleNext}
                className=" rounded-full btnGraiden bg-[#333333] shadowBTNs  text-white font-mainFont font-[500] min-w-[30%] py-3 px-6 text-[1vw] mt-[2%]"
              >
                Next
              </button>
            </div>
          </>
        );
        break;
      case 4:
        return (
          <>
            <div className="flex flex-col justify-center items-center gap-4 my-3 w-[30%]">
              <label className="text-[#333333] font-mainFont font-[600] text-center text-[1.1vw]">
                {allMedications[currentMedication].title}
              </label>
              <input
                className="w-full py-3 rounded-full font-mainFont placeholder:font-[400] font-[500] px-4 border border-[#CDCDCD] bg-[#F8F8F8] inputShadow focus:ring-none outline-none"
                placeholder="Enter Period taken"
                type="number"
              />
            </div>
            <div className="w-[30%] flex justify-around items-center ">
              <button
                type="button"
                onClick={handlePrevious}
                className=" rounded-full btnGraiden bg-[#333333] shadowBTNs  text-white font-mainFont font-[500] min-w-[30%] py-3 px-6 text-[1vw] mt-[2%]"
              >
                Previous
              </button>
              {/* <button
                type="button"
                onClick={handleNext}
                className=" rounded-full btnGraiden bg-[#333333] shadowBTNs  text-white font-mainFont font-[500] min-w-[30%] py-3 px-6 text-[1vw] mt-[2%]"
              >
                Next
              </button> */}
            </div>
          </>
        );
        break;

      default:
        return (
          <>
            <button
              type="button"
              onClick={() => setAddMedication(() => addMedication + 1)}
              className=" rounded-full btnGraiden bg-[#317BDB] shadowBTNs  text-white font-mainFont font-[500] min-w-[15%] py-3 px-6 text-[1vw] mt-[2%]"
            >
              {allMedications[currentMedication].title} +
            </button>
          </>
        );
        break;
    }
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setMedicationInfo({ ...medicationInfo, [name]: value });
  };

  const handleDelete = (id) => {
    // Confirm deletion
    if (!window.confirm("Are you sure you want to delete this medication?")) {
      return;
    }
    
    // Delete from addedMedication state
    setAddedMedication((preData) => {
      const safePreData = Array.isArray(preData) ? preData : [];
      return safePreData.filter((item, index) => index !== id);
    });
    
    // Delete from patientMedicationInfo
    setPatientMedicationInfo((preData) => {
      const safeArray = Array.isArray(preData.medicationForPainList)
        ? preData.medicationForPainList
        : [];
      
      return {
        ...preData,
        medicationForPainList: safeArray.filter((_, index) => index !== id),
      };
    });
  };

  return (
    <div className="px-4 py-3 mb-5 ">
      <div className="w-full">
        <div class="relative bg-white p-2 rounded overflow-x-auto flex justify-center items-center flex-col">
          <div className="w-full flex flex-col gap-10 mb-6">
            <div className="2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[80%] w-full">
              <div className="my-2 flex flex-col gap-8 2xl:p-6 xl:p-6 lg:p-6 md:p-6 p-2 shado border-b border-[#d4d4d4]">
                <p className="font-mainFont font-[600] 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.2vw] text-white">
                  Do you take any medication for pain?
                </p>
                <div className="flex justify-start items-center gap-4">
                  <button
                    onClick={() => {
                      setHaveDisabilityForPain("Yes"); 
                      setPatientMedicationInfo({
                        ...patientMedicationInfo,
                        doTakeMedicationForPain:'Yes'
                      })                     
                    }}
                    className={`text-[#333333] ${
                      patientMedicationInfo.doTakeMedicationForPain === "Yes"
                        ? "text-white BTNGradientBg"
                        : "text-black bg-white"
                    }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => {
                      setHaveDisabilityForPain("No");
                      setPatientMedicationInfo({
                        ...patientMedicationInfo,
                        doTakeMedicationForPain:'No'
                      })
                    }}
                    className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                      patientMedicationInfo.doTakeMedicationForPain === "No"
                        ? "text-white BTNGradientBg"
                        : "text-black bg-white"
                    }`}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>

            {patientMedicationInfo.doTakeMedicationForPain === "Yes" && (
              <>
                <div class="relative overflow-x-auto">
                  <table class="w-full text-sm text-left rtl:text-right   font-mainFont bg-white">
                    <thead class="text-xs  uppercase   text-black border-t  border-[#d4d4d4]">
                      <tr>
                        <th
                          scope="col"
                          class="px-6 py-3 font-[600] border-l border-r border-[#d4d4d4]"
                        >
                          Medication
                        </th>
                        <th scope="col" class="px-6 py-3 font-[600]">
                          Dosage
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3 border-l border-r border-[#d4d4d4] font-[600]"
                        >
                          Frequency
                        </th>

                        <th
                          scope="col"
                          class="px-6 py-3 border-l border-r border-[#d4d4d4] font-[600]"
                        >
                          Period Approx. Taken
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {Array(addMedication)
                        .join()
                        .split(",")
                        .map((cur, id) => (
                          <tr key={id} class="bg-white text-black border-b   ">
                            <th
                              scope="row"
                              class="font-medium text-black whitespace-nowrap border border-[#d4d4d4]"
                            >
                              <input
                                className="w-full px-3 py-4 border border-none outline-none"
                                placeholder="Enter medication name"
                                name="medication"
                                value={medicationInfo.medication}
                                onChange={handleOnChange}
                              />
                            </th>
                            <td class=" border border-[#d4d4d4]">
                              <input
                                className="w-full px-3 py-4 border border-none outline-none"
                                placeholder="Enter Dose Amount"
                                type="number"
                                name="dosage"
                                value={medicationInfo.dosage}
                                onChange={handleOnChange}
                              />
                            </td>
                            <td class=" border border-[#d4d4d4] text-[#34495E] font-[400] font-[Poppins] p-2">
                              <div className="flex flex-col gap-2">
                                <select
                                  onChange={handleOnChange}
                                  name="frequency"
                                  value={medicationInfo.frequency}
                                  className="w-full bg-transparent h-full p-3 border-none outline-none"
                                >
                                  <option value="">Select</option>
                                  <option value="Daily">Daily</option>
                                  <option value="Twice a week">Twice a week</option>
                                  <option value="More than twice a week">More than twice a week</option>
                                  <option value="Weekly">Weekly</option>
                                  <option value="Other">Other</option>
                                </select>
                                {medicationInfo.frequency === "Other" && (
                                  <input
                                    type="text"
                                    name="frequencyOther"
                                    value={medicationInfo.frequencyOther}
                                    onChange={handleOnChange}
                                    placeholder="Please specify frequency..."
                                    className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none bg-white text-black"
                                  />
                                )}
                              </div>
                            </td>
                            <td class=" border border-[#BDC3C7]">
                              <input
                                className="w-full px-3 py-4 border border-none outline-none"
                                placeholder="Enter Period taken"
                                type="number"
                                name="taken"
                                value={medicationInfo.taken}
                                onChange={handleOnChange}
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <button
                    type="button"
                    onClick={() => {
                      // Validate that at least medication name is provided
                      if (!medicationInfo.medication || medicationInfo.medication.trim() === "") {
                        alert("Please enter a medication name before adding.");
                        return;
                      }
                      
                      // If frequency is "Other", use the custom text, otherwise use the selected frequency
                      const frequencyValue = medicationInfo.frequency === "Other" 
                        ? (medicationInfo.frequencyOther.trim() || "Other")
                        : medicationInfo.frequency;
                      
                      // Create medication object
                      const newMedication = {
                        medication: medicationInfo.medication.trim(),
                        dosage: medicationInfo.dosage.trim(),
                        frequency: frequencyValue,
                        taken: medicationInfo.taken.trim(),
                      };
                      
                      // Add to addedMedication state
                      setAddedMedication([...addedMedication, newMedication]);
                      
                      // Add to patientMedicationInfo
                      const currentArray = Array.isArray(patientMedicationInfo?.medicationForPainList)
                        ? patientMedicationInfo.medicationForPainList
                        : [];
                      
                      setPatientMedicationInfo({
                        ...patientMedicationInfo,
                        medicationForPainList: [...currentArray, newMedication],
                      });
                      
                      // Clear the form
                      setMedicationInfo({
                        medication: "",
                        dosage: "",
                        frequency: "",
                        frequencyOther: "",
                        taken: "",
                      });
                    }}
                    className="bg-secondaryColo BTNGradientBg  text-white font-mainFont font-[500] w-full py-3 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.5vw] hover:opacity-90 transition-all duration-200"
                  >
                    Add Medication
                  </button>
                </div>

                <div className=" flex justify-start w-full  gap-5 flex-wrap my-5">
                  {patientMedicationInfo?.medicationForPainList.map((curMedication, id) => (
                    <div
                      key={id}
                      className="border border-[#d4d4d4] bg-white p-5 rounded-xl flex flex-col gap-4 2xl:min-w-[20dvw] xl:min-w-[20dvw] lg:min-w-[20dvw] md:min-w-[20dvw] min-w-[80dvw]"
                    >
                      <div className="flex justify-between items-center">
                        <h3 className="2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw] font-[700] text-[#333333]">
                          Medication {id + 1}
                        </h3>
                        <div className="flex gap-2">
                          <button
                            onClick={() => {
                              // Load medication into form for editing
                              setMedicationInfo({
                                medication: curMedication?.medication || "",
                                dosage: curMedication?.dosage || "",
                                frequency: curMedication?.frequency || "",
                                frequencyOther: curMedication?.frequency === "Other" ? curMedication?.frequency : "",
                                taken: curMedication?.taken || "",
                              });
                              setEditingIndex(id);
                            }}
                            className="p-2 flex justify-center items-center hover:text-white hover:bg-blue-400 transition-all duration-200 ease-linear rounded-full shadow-lg"
                            title="Edit medication"
                          >
                            ✏️
                          </button>
                          <button
                            onClick={() => handleDelete(id)}
                            className="p-2 flex justify-center items-center hover:text-white hover:bg-red-400 transition-all duration-200 ease-linear rounded-full shadow-lg"
                            title="Delete medication"
                          >
                            <Trash size={15} />
                          </button>
                        </div>
                      </div>
                      {editingIndex === id ? (
                        // Edit mode
                        <div className="flex flex-col gap-3">
                          <input
                            className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none"
                            placeholder="Medication name"
                            value={medicationInfo.medication}
                            onChange={(e) => setMedicationInfo({...medicationInfo, medication: e.target.value})}
                          />
                          <input
                            className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none"
                            placeholder="Dosage"
                            type="number"
                            value={medicationInfo.dosage}
                            onChange={(e) => setMedicationInfo({...medicationInfo, dosage: e.target.value})}
                          />
                          <select
                            className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none"
                            value={medicationInfo.frequency}
                            onChange={(e) => setMedicationInfo({...medicationInfo, frequency: e.target.value})}
                          >
                            <option value="">Select</option>
                            <option value="Daily">Daily</option>
                            <option value="Twice a week">Twice a week</option>
                            <option value="More than twice a week">More than twice a week</option>
                            <option value="Weekly">Weekly</option>
                            <option value="Other">Other</option>
                          </select>
                          {medicationInfo.frequency === "Other" && (
                            <input
                              type="text"
                              className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none"
                              placeholder="Specify frequency..."
                              value={medicationInfo.frequencyOther}
                              onChange={(e) => setMedicationInfo({...medicationInfo, frequencyOther: e.target.value})}
                            />
                          )}
                          <input
                            className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none"
                            placeholder="Period taken"
                            type="number"
                            value={medicationInfo.taken}
                            onChange={(e) => setMedicationInfo({...medicationInfo, taken: e.target.value})}
                          />
                          <div className="flex gap-2">
                            <button
                              onClick={() => {
                                // Save edited medication
                                const frequencyValue = medicationInfo.frequency === "Other" 
                                  ? (medicationInfo.frequencyOther.trim() || "Other")
                                  : medicationInfo.frequency;
                                
                                const updatedMedication = {
                                  medication: medicationInfo.medication.trim(),
                                  dosage: medicationInfo.dosage.trim(),
                                  frequency: frequencyValue,
                                  taken: medicationInfo.taken.trim(),
                                };
                                
                                const updatedList = [...patientMedicationInfo.medicationForPainList];
                                updatedList[id] = updatedMedication;
                                
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  medicationForPainList: updatedList,
                                });
                                
                                // Clear form and exit edit mode
                                setMedicationInfo({
                                  medication: "",
                                  dosage: "",
                                  frequency: "",
                                  frequencyOther: "",
                                  taken: "",
                                });
                                setEditingIndex(null);
                              }}
                              className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                            >
                              Save
                            </button>
                            <button
                              onClick={() => {
                                // Cancel editing
                                setMedicationInfo({
                                  medication: "",
                                  dosage: "",
                                  frequency: "",
                                  frequencyOther: "",
                                  taken: "",
                                });
                                setEditingIndex(null);
                              }}
                              className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        // View mode
                        <>
                          <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                            <strong>Medication</strong> :{" "}
                            <span className="font-[400] text-black  2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw]">
                              {curMedication?.medication}
                            </span>
                          </h3>
                          <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                            <strong>Dosage</strong> :{" "}
                            <span className="font-[400] text-black 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw]">
                              {curMedication?.dosage}
                            </span>
                          </h3>
                          <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                            <strong>Frequency</strong> :{" "}
                            <span className="font-[400] text-black 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw]">
                              {curMedication?.frequency}
                            </span>
                          </h3>
                          <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                            <strong>Period Approx. Taken</strong> :{" "}
                            <span className="text-black font-[400] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw]">
                              {curMedication?.taken}
                            </span>
                          </h3>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
